import _ from "lodash";
import Accessor from "./Accessor";
import ZArray from "./ZArray";
import ReqConfig from "__SYSDefault/_ReqConfig";

class FormAttachmentX {

  /**
   * 
   * @param {*} formData 
   * @param {String} fieldKey 
   * @param {String} linkRef 
   * @returns 
   */
  static SeparateAndLink(formData, fieldKey = ReqConfig.AttachmentFieldKey, linkRef = ReqConfig.AttachmentLinkRef){
    let _formData = _.cloneDeep(formData);
    let allFields = Accessor.ExtractSpecificFieldName(_formData, fieldKey);
    let allAssets = [];
    _.map(allFields, (o, i) => {
      let value = Accessor.Get(_formData, o);
      let images;
      if(value instanceof FileList){
        images = value;
      }else{
        images = ZArray.Ensure(value);
      }

      //check existing
      let list = [];
      _.map(images, (v, j) => {
        if(v.active) {
          list.push(v);
          return;
        }
        let file = v.oriFile ?? v;
        let {fileSize, fromCamera, timestamp, height, width, 
          type, name, dimensions} = file;
        allAssets.push(file);
        list.push({
          alias: linkRef + (allAssets.length - 1),
          fileSize: fileSize,
          fromCamera: fromCamera,
          timestamp: timestamp ?? "",
          height: height,
          width: width,
          type: type,
          originalName: name,
          dimensions: dimensions ?? undefined
        });
      });
      console.log(list);
      Accessor.Set(_formData, o, list);
    });

    return {
      allAssets: allAssets,
      linkedFormData: _formData
    };

  }

}

export default FormAttachmentX;